/* ProgressComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ProgressRenderer");

/**
 * A ProgressComponent namespace.
 * @namespace Progress
 */

/**
 * @class ProgressComponent
 * @extends EventEmitter
 *
 * @fires ProgressComponent#Shutdown
 * @fires ProgressComponent#Progress
 *
 */

class ProgressComponent extends EventEmitter {
    constructor(opts) {
        super(opts);
        this._message = opts.message;
        this._registerListeners();
        this._renderer = new Renderer(this);
        this.data = [];
    }

    get renderer() {
        return this.getRenderer();
    }

    get rootElem() {
        return this._renderer.getRootElement();
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    _triggerShutdown() {
        /**
         * @event ProgressComponent#Shutdown
         * @param {ProgressComponent}
         */
        this.emit("Shutdown", this);
    }

    _triggerProgress(msg) {
        /**
         * @event ProgressComponent#Progress
         * @param {Object}
         */
        this.emit("Progress", msg);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._triggerShutdown();
        this._unregisterListeners();
        const shutdownProm = [];

        if (this._renderer) {
            shutdownProm.push(this._renderer.shutdown());
        }

        return Promise.all(shutdownProm).then(
            () => {
                this.removeAllListeners();
                this._renderer = undefined;
            },
            (/*err*/) => {}
        );
    }

    reject(error) {
        this._context.reject(error);
    }

    resolve(data) {
        this._context.resolve(data);
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    abortProgress() {
        this.reject({aborted: true});
    }

    close() {
        this.resolve({closed: true});
    }

    setProgress(msg) {
        if (msg === "done") {
            return this.resolve();
        }

        this._triggerProgress(msg);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}
module.exports = ProgressComponent;
